import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithTokenRefresh } from '@services/utils/query.ts';

export const apiService = createApi({
  baseQuery: baseQueryWithTokenRefresh,
  tagTypes: ['Companies'],
  refetchOnReconnect: true,
  endpoints: () => ({})
});
